import * as React from 'react';
import produce from 'immer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { H2 } from 'UIComponents/elements/headings';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const arePropertiesEqual = (oldProperty, newProperty) => {
  return oldProperty.label === newProperty.label;
};
const WebhookPropertyEditPanelContents = ({
  propertyEditIndex,
  stagedWebhookDefinition,
  setStagedWebhookDefinition,
  onClose
}) => {
  const displayedProperty = stagedWebhookDefinition.eventProperties[propertyEditIndex];
  const [stagedProperty, setStagedProperty] = React.useState(displayedProperty);
  const hasPropertyLabel = !!stagedProperty.label;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.title"
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsxs(UIPanelSection, {
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          required: true,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.propertyName.label"
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.propertyName.tooltip"
          }),
          error: !hasPropertyLabel,
          validationMessage: !hasPropertyLabel && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.errors.propertyName"
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            value: stagedProperty.label,
            onChange: ({
              target: {
                value
              }
            }) => setStagedProperty(property => Object.assign({}, property, {
              label: value
            }))
          })
        }), /*#__PURE__*/_jsx(UIFormControl, {
          required: true,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.webhookSource.label"
          }),
          help: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.webhookSource.help"
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.webhookSource.tooltip"
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            value: stagedProperty.propertyName,
            readOnly: true
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(UIPanelFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !arePropertiesEqual(displayedProperty, stagedProperty) && hasPropertyLabel,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.saveChangesTooltip"
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          disabled: arePropertiesEqual(displayedProperty, stagedProperty) || !hasPropertyLabel,
          onClick: () => {
            setStagedWebhookDefinition(produce(staged => {
              staged.eventProperties[propertyEditIndex] = stagedProperty;
            }));
            onClose();
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.saveChanges"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onClose,
        responsive: false,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookProperty.back"
        })
      })]
    })]
  });
};
export default WebhookPropertyEditPanelContents;